import { useState, useRef, useEffect } from "react";

const cases = [
  {
    id: "solyun",
    name: "김소연",
    handle: "@solyun.art",
    category: "수채화 일러스트레이터",
    brandName: "솔밭(Solbat)",
    brandDesc: "감성 문구 · 리빙 굿즈 D2C 브랜드",
    plan: "파트너형",
    planColor: "#A855F7",
    duration: "런칭 후 8개월",
    img: "https://public.readdy.ai/ai/img_res/c745b7b5f9a5de4d939f67658cf2b049.jpg",
    metrics: [
      { icon: "ri-store-2-line", label: "누적 주문", value: "4,200건", color: "#A855F7" },
      { icon: "ri-money-dollar-circle-line", label: "월 평균 매출", value: "820만원", color: "#14F1D9" },
      { icon: "ri-heart-line", label: "인스타 팔로워", value: "32.4K", color: "#F97316" },
    ],
    quote: "저는 그냥 그림 그리는 사람이었어요. 아르트레너를 만나고 나서야 제 그림이 '브랜드'가 될 수 있다는 걸 처음 알았어요.",
    tags: ["브랜드 & IP", "D2C 쇼핑몰", "GTM 전략"],
    tagColors: ["rgba(168,85,247,0.2)", "rgba(20,241,217,0.15)", "rgba(249,115,22,0.15)"],
    accentColor: "#A855F7",
    glowColor: "rgba(168,85,247,0.15)",
  },
  {
    id: "junhyuk",
    name: "박준혁",
    handle: "@j.media.art",
    category: "미디어 아티스트",
    brandName: "FLUX STUDIO",
    brandDesc: "디지털 아트 구독 플랫폼 + 한정판 에디션",
    plan: "스케일업형",
    planColor: "#14F1D9",
    duration: "런칭 후 14개월",
    img: "https://readdy.ai/api/search-image?query=korean%20male%20media%20artist%20in%20dark%20futuristic%20studio%20surrounded%20by%20glowing%20screens%20displaying%20abstract%20digital%20art%2C%20neon%20purple%20and%20teal%20lighting%2C%20professional%20photography%2C%20moody%20atmospheric%20lighting%2C%20tech%20aesthetic%20workspace&width=400&height=480&seq=case-artist-junhyuk-002&orientation=portrait",
    metrics: [
      { icon: "ri-vip-crown-line", label: "유료 구독자", value: "847명", color: "#A855F7" },
      { icon: "ri-price-tag-3-line", label: "에디션 단가", value: "평균 58만원", color: "#14F1D9" },
      { icon: "ri-bar-chart-2-line", label: "수익 성장", value: "+310%", color: "#F97316" },
    ],
    quote: "IT 인프라 없이 어떻게 구독 플랫폼을 만드냐고요? 아르트레너가 다 해줬어요. 저는 작품만 만들었을 뿐입니다.",
    tags: ["멤버십 플랫폼", "정기결제 연동", "백오피스"],
    tagColors: ["rgba(20,241,217,0.15)", "rgba(168,85,247,0.15)", "rgba(192,132,252,0.15)"],
    accentColor: "#14F1D9",
    glowColor: "rgba(20,241,217,0.12)",
  },
  {
    id: "harin",
    name: "이하린",
    handle: "@harin.ceramic",
    category: "세라믹 도예가",
    brandName: "하린 스튜디오",
    brandDesc: "프리미엄 핸드메이드 리빙 세라믹 브랜드",
    plan: "인큐베이팅형",
    planColor: "#F97316",
    duration: "런칭 후 11개월",
    img: "https://readdy.ai/api/search-image?query=korean%20female%20ceramic%20artist%20working%20with%20clay%20in%20a%20warm%20minimalist%20pottery%20studio%2C%20handmade%20ceramic%20pieces%20displayed%20on%20shelves%2C%20soft%20natural%20light%20through%20windows%2C%20elegant%20and%20artistic%20atmosphere%2C%20professional%20lifestyle%20photography%2C%20warm%20tones&width=400&height=480&seq=case-artist-harin-003&orientation=portrait",
    metrics: [
      { icon: "ri-store-3-line", label: "팝업 스토어", value: "3회 진행", color: "#F97316" },
      { icon: "ri-money-dollar-circle-line", label: "누적 매출", value: "4,200만원", color: "#14F1D9" },
      { icon: "ri-user-star-line", label: "리텐션율", value: "68%", color: "#A855F7" },
    ],
    quote: "초기 자본이 0원이었어요. 근데 지금은 백화점 팝업을 열고 있어요. 제 인생이 완전히 바뀐 거예요.",
    tags: ["인큐베이팅", "팝업 전시 기획", "IP 보호"],
    tagColors: ["rgba(249,115,22,0.2)", "rgba(20,241,217,0.15)", "rgba(168,85,247,0.15)"],
    accentColor: "#F97316",
    glowColor: "rgba(249,115,22,0.12)",
  },
];

export default function CaseStudies() {
  const [active, setActive] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll("[data-case-animate]");
            els.forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = "1";
                (el as HTMLElement).style.transform = "translateY(0)";
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const current = cases[active];

  return (
    <section
      id="cases"
      className="relative py-24 lg:py-44 px-4 md:px-6 overflow-hidden"
      style={{ background: "linear-gradient(180deg, #06080F 0%, #0A0B16 60%, #06080F 100%)" }}
    >
      {/* BG Glow */}
      <div
        className="absolute inset-0 pointer-events-none transition-all duration-700"
        style={{ background: `radial-gradient(ellipse at 60% 50%, ${current.glowColor} 0%, transparent 65%)` }}
      />

      <div ref={sectionRef} className="max-w-7xl mx-auto">
        {/* Header */}
        <div
          data-case-animate
          className="text-center mb-14 lg:mb-24"
          style={{ opacity: 0, transform: "translateY(20px)", transition: "opacity 0.6s ease, transform 0.6s ease" }}
        >
          <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-orange mb-5 px-3 py-1 rounded-full border border-brand-orange/30 bg-brand-orange/5">
            Success Stories
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug lg:leading-relaxed">
            먼저 시작한 아티스트들의<br />
            <span className="gradient-text-brand">실제 이야기</span>
          </h2>
          <p className="mt-5 text-white/50 font-body text-sm md:text-base max-w-lg mx-auto leading-loose">
            거창한 홍보 문구가 아닌, 실제 파트너 아티스트의 숫자로 말합니다.
          </p>
        </div>

        {/* Tab Selector */}
        <div
          data-case-animate
          className="flex justify-center mb-10 lg:mb-14"
          style={{ opacity: 0, transform: "translateY(20px)", transition: "opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s" }}
        >
          <div
            className="flex gap-1 p-1 rounded-2xl"
            style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
          >
            {cases.map((c, i) => (
              <button
                key={c.id}
                onClick={() => setActive(i)}
                className={`px-4 md:px-5 py-2.5 rounded-xl text-xs md:text-sm font-display font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  active === i ? "text-white" : "text-white/40 hover:text-white/70"
                }`}
                style={
                  active === i
                    ? { background: c.accentColor + "22", border: `1px solid ${c.accentColor}40`, color: c.accentColor }
                    : {}
                }
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>

        {/* Main Case Card */}
        <div
          data-case-animate
          className="glass rounded-3xl overflow-hidden"
          style={{
            opacity: 0,
            transform: "translateY(20px)",
            transition: "opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s",
            border: `1px solid ${current.accentColor}20`,
          }}
        >
          <div className="flex flex-col lg:flex-row min-h-0">
            {/* Left: Image */}
            <div className="relative w-full lg:w-72 xl:w-96 flex-shrink-0 h-72 lg:h-auto overflow-hidden">
              <img
                key={current.img}
                src={current.img}
                alt={current.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-500"
              />
              {/* Overlay gradient */}
              <div
                className="absolute inset-0"
                style={{ background: "linear-gradient(to bottom, transparent 40%, rgba(6,8,15,0.9) 100%)" }}
              />
              <div
                className="absolute inset-0 hidden lg:block"
                style={{ background: "linear-gradient(to right, transparent 60%, rgba(6,8,15,0.6) 100%)" }}
              />
              {/* Plan badge */}
              <div className="absolute top-4 left-4">
                <span
                  className="px-3 py-1 rounded-full text-xs font-display font-bold"
                  style={{ background: current.accentColor + "30", color: current.accentColor, border: `1px solid ${current.accentColor}40` }}
                >
                  {current.plan}
                </span>
              </div>
              {/* Name overlay (mobile) */}
              <div className="absolute bottom-4 left-4 lg:hidden">
                <p className="font-display font-bold text-white text-xl">{current.name}</p>
                <p className="text-white/60 text-xs font-body mt-0.5">{current.category}</p>
              </div>
            </div>

            {/* Right: Content */}
            <div className="flex-1 p-6 lg:p-10 xl:p-12 flex flex-col gap-7 lg:gap-8">
              {/* Name + Brand (desktop) */}
              <div className="hidden lg:flex items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-display text-2xl font-bold text-white">{current.name}</h3>
                    <span className="text-white/40 text-sm font-body">{current.handle}</span>
                  </div>
                  <p className="text-white/50 text-sm font-body">{current.category}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="font-display font-bold text-white text-lg">{current.brandName}</p>
                  <p className="text-white/40 text-xs font-body mt-1">{current.brandDesc}</p>
                </div>
              </div>

              {/* Brand name (mobile) */}
              <div className="lg:hidden">
                <p className="font-display font-bold text-white text-base">{current.brandName}</p>
                <p className="text-white/40 text-xs font-body mt-0.5">{current.brandDesc}</p>
              </div>

              {/* Metrics */}
              <div className="grid grid-cols-3 gap-3 lg:gap-5">
                {current.metrics.map((m) => (
                  <div
                    key={m.label}
                    className="rounded-2xl p-3 lg:p-5 flex flex-col gap-2 lg:gap-3"
                    style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)" }}
                  >
                    <div className="w-7 h-7 lg:w-9 lg:h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: m.color + "18" }}>
                      <i className={`${m.icon} text-sm lg:text-base`} style={{ color: m.color }} />
                    </div>
                    <p className="font-display font-bold text-white text-sm md:text-base lg:text-lg leading-none">{m.value}</p>
                    <p className="text-white/40 text-xs font-body leading-snug">{m.label}</p>
                  </div>
                ))}
              </div>

              {/* Quote */}
              <div
                className="rounded-2xl p-5 lg:p-7 relative overflow-hidden"
                style={{ background: `${current.accentColor}08`, border: `1px solid ${current.accentColor}20` }}
              >
                <i
                  className="ri-double-quotes-l text-4xl absolute top-3 right-5 opacity-10"
                  style={{ color: current.accentColor }}
                />
                <p className="text-white/75 text-sm md:text-base font-body leading-loose italic">
                  &ldquo;{current.quote}&rdquo;
                </p>
                <div className="flex items-center gap-2 mt-4">
                  <div className="w-1 h-4 rounded-full flex-shrink-0" style={{ background: current.accentColor }} />
                  <p className="text-xs font-display font-semibold" style={{ color: current.accentColor }}>
                    {current.name} — {current.duration}
                  </p>
                </div>
              </div>

              {/* Tags + CTA Row */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-auto pt-2">
                <div className="flex flex-wrap gap-2">
                  {current.tags.map((tag, ti) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs font-body text-white/60"
                      style={{ background: current.tagColors[ti], border: "1px solid rgba(255,255,255,0.08)" }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href="#canvas"
                  className="flex-shrink-0 flex items-center gap-2 px-5 py-2.5 rounded-full text-xs md:text-sm font-display font-semibold text-white cursor-pointer whitespace-nowrap transition-all duration-300"
                  style={{
                    background: `linear-gradient(135deg, ${current.accentColor}, ${current.accentColor}aa)`,
                    boxShadow: `0 0 16px ${current.accentColor}30`,
                  }}
                >
                  나도 시작하기
                  <i className="ri-arrow-right-line text-xs" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Case Dots */}
        <div className="flex items-center justify-center gap-2 mt-8">
          {cases.map((c, i) => (
            <button
              key={c.id}
              onClick={() => setActive(i)}
              className="rounded-full transition-all duration-300 cursor-pointer"
              style={{
                width: active === i ? "24px" : "8px",
                height: "8px",
                background: active === i ? c.accentColor : "rgba(255,255,255,0.2)",
              }}
              aria-label={`${c.name} 케이스 보기`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
